import { Component, ViewEncapsulation, Input } from '@angular/core';

export enum RegistrationStep {
    /**
     * Em preenchimento
     */
    Registration,
    /**
     * Aguardando validações ou integrções
     */
    Validating,
    /**
     * Aguardando tranferencia de valores para a conta
     */
    MoneyTransfer,
}

export enum ListProgress {
    Current,
    Success,
    Waiting,
}

const ListProgressClassMap = {
    [ListProgress.Current]: 'list-progress-status--alert',
    [ListProgress.Success]: 'list-progress-status--success',
    [ListProgress.Waiting]: 'list-progress-status--default',
}

@Component({
    selector: 'registration-status-card',
    templateUrl: './registration-status-card.component.html',
    styleUrls: ['./registration-status-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [],
})
export class RegistrationStatusCardComponent  {
    @Input() public estimatedTime?: string;
    @Input() public statusDescription?: string;
    @Input() public registrationStep?: RegistrationStep = RegistrationStep.Registration;

    public registrationProgress = {
        status: ListProgress.Waiting,
        class: 'list-progress-status--default'
    };
    public validatingProgress = {
        status: ListProgress.Waiting,
        class: 'list-progress-status--default'
    };
    public moneyTransferProgress = {
        status: ListProgress.Waiting,
        class: 'list-progress-status--default'
    };

    public listProgress = ListProgress;

    public ngOnInit() {
        switch (this.registrationStep) {
            case RegistrationStep.Registration:
                this.registrationProgress.class = ListProgressClassMap[ListProgress.Current];
                this.registrationProgress.status = ListProgress.Current;
                break;
            case RegistrationStep.Validating:
                this.registrationProgress.class = ListProgressClassMap[ListProgress.Success];
                this.registrationProgress.status = ListProgress.Success;
                this.validatingProgress.class = ListProgressClassMap[ListProgress.Current];
                this.validatingProgress.status = ListProgress.Current;
                break;
            case RegistrationStep.MoneyTransfer:
                this.registrationProgress.class = ListProgressClassMap[ListProgress.Success];
                this.registrationProgress.status = ListProgress.Success;
                this.validatingProgress.class = ListProgressClassMap[ListProgress.Success];
                this.validatingProgress.status = ListProgress.Success;
                this.moneyTransferProgress.class = ListProgressClassMap[ListProgress.Current];
                this.moneyTransferProgress.status = ListProgress.Current;
                break;
            default:
                break;
        }
    }
}
